import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from '../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../Terms';

import { commonStyles } from '../../../styles/styles';
import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";



const SeventhPage = ({ classes, form, ...props, previousPage }) => {
  const { handleSubmit} = props;
  
  const checkboxValue =
    form.registration && form.registration.values && form.registration.values.Terms;
  return (
      <div className={classes.regFormWrapper}>
        <form className="pr-3 pl-3" onSubmit={handleSubmit} style={{top:170, height:'100%',overflow:'auto'}}>
        <div>
          {/*<Field
            name="conClientTrainingRegionID"
            component={DropdownField}
            data={data.training}
            labelText="Training Region (optional)"
          />*/}
          <p className={classes.title}>
          Pre-Assessment Agreement (Applicable to Learnerships)
          </p>
          <p></p>
          <p className={classes.para}>• Do you understand how the assessments will take place?</p>
          <p className={classes.para}>• Do you understand the appeals procedure?</p>
          <p className={classes.para}>• Do you feel you have the learning resources required?</p>
          <p className={classes.para}>• If you have any special needs has this been addressed adequately by the Learnership Team?</p>
          <p className={classes.para}>• Do you understand how the unit standards fit into the qualification?</p>
          <p className={classes.para}>• Do you understand the assessment instrument/s that will be used?</p>
          <p className={classes.para}>• Do you understand the evidence needed for achieving the outcomes of the qualification?</p>
          <p className={classes.para}>• Do you understand the principles of assessment?</p>
          <p className={classes.para}>• I understand that Cornerstone Performance Solutions embraces the fundamental benefits of group work whereby we are able to share diverse perspectives and challenge assumptions with one another. However the assignment submissions required as part of my portfolio of evidence will be my own work.</p>
          <p className={classes.para}>• Do you understand that should you not finish the Learnership within the contractual period (12 months), and you wish to finish your qualification with Cornerstone, you will be liable to pay the necessary penalties as stipulated by Cornerstone’s Late Qualification Policy.</p>
          <p></p>
          <p className={classes.title}>Learner Declaration</p>
          <p></p>
          <p className={classes.para}>1. I declare that all the information and answers provided in my assignments and activity worksheets will be my own work.</p>
          <p className={classes.para}>2. I will not copy from other people or provide them with my answers.</p>
          <p className={classes.para}>3. I will keep my Username and Password Confidential to prevent plagiarism / fraud.</p>
          <p className={classes.para}>4. I understand that should I be found guilty of plagiarism and/or copying from other learners, I am committing academic fraud and disciplinary steps will be followed as agreed between CPS and the relevant employer.</p>
        </div>
     
          <div className={`${classes.halfField2} ${classes.noTopLabel}`}>
            <Field
              name="Terms"
              component={RenderCheckbox}
              label=""
              checkedStatus={checkboxValue}
             
            />
          </div>
          <div>
          <MDBRow className="mt-2">
            <MDBCol size="6">
              <MDBBtn 
                  right
                  size="md"
                  className='mt-0 mb-2 float-left danger-color-dark'
                  action
                  onClick={previousPage}
                  type="button">
                PREVIOUS
              </MDBBtn>
            </MDBCol>
            <MDBCol size="6">
              <MDBBtn color="success"
                  right
                  size="md"
                  className='ml-3 mr-2 mt-0 mb-2 float-right'
                  action
                  type="submit">
                REGISTER
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </div>
      </form>
    </div>
  ) 
}



SeventhPage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  login: PropTypes.instanceOf(Object),
  form: PropTypes.instanceOf(Object),
};

const styles = () => ({
  ...commonStyles,
  halfField2: {
    display: 'inline-flex',
    width: '75%',
  },
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '2%',
  },
  label: {
    color: '#e84848',
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    margin: '0 auto 200',
    padding: '0 10'
    
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'PTSans-Bold',

  },
  para:{
    fontFamily: 'PTSans-Regular',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'left'
  },
  title:{
    fontFamily: 'PTSans-Bold',
    fontSize: '18px',
    lineHeight: '22px',
  }
});

export default compose(
  reduxForm({  form: 'registration',                 // <------ same form name
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
}),
withStyles(styles),
)(SeventhPage);



// WEBPACK FOOTER //
// ./src/Components/Form/RegistrationSteps/SeventhPage.js